import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { Models } from 'models/core';
import { ErrorService } from 'services/error-service';
import { LoopPositionVerticalService } from 'services/loop-position-vertical-service';

@autoinject
export class LoopPositionVertical {
  private tableData: Array<Models.LoopPositionVertical>;
  private activeTableRow: number;
  private ready: boolean = false;

  constructor(
    private loopPositionVertical: LoopPositionVerticalService,
    private errorService: ErrorService,
    private router: Router,
    private eventAggregator: EventAggregator
  ) {}

  private activate(params) {
    if (params.Id) {
      this.activeTableRow = params.Id;
    } else {
      this.activeTableRow = 0;
    }
  }

  private attached(params) {
    this.eventAggregator.subscribe('loopPositionVerticalListReset', (value) => {
      this.activeTableRow = null;
      return this.updateView();
    });
    this.updateView();
  }

  private updateView() {
    this.loopPositionVertical
      .getAll()
      .then((res) => {
        this.ready = true;
        this.tableData = res;
      })
      .catch((err) => this.errorService.handleError(err));
  }

  private gotoDetailView(id) {
    this.activeTableRow = id;
    this.router.navigateToRoute('loop-position-vertical-detail', { Id: id });
  }
}
